import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { HomepageComponent } from "../homepage/homepage.component";
import { NavbarComponent } from "./navbar.component";
import { AboutComponent } from "../about/about.component";
import { HistoryComponent } from "../history/history.component";
import { AwardsComponent } from '../awards/awards.component';
import { RulesComponent } from '../rules/rules.component';
import { ArchersComponent } from '../archers/archers.component';
import { AchievementsComponent } from '../achievements/achievements.component';
import { CalanderComponent } from '../calander/calander.component';
import { NewsComponent } from '../news/news.component';
import { ComplianceComponent } from '../compliance/compliance.component';
import { JudgesComponent } from '../judges/judges.component';
import { NewsDetailComponent } from '../news-detail/news-detail.component';
import { ExecutiveCommiteeComponent } from '../executive-commitee/executive-commitee.component';
import { CommittesComponent } from '../committes/committes.component';
import { GcComponent } from '../gc/gc.component';

import { AnnualAccountsComponent } from '../annual-accounts/annual-accounts.component';
import { ResultsComponent } from '../results/results.component';
import { EventsComponent } from '../events/events.component';
import { EventDetailsComponent } from '../event-details/event-details.component';
import { FameHallComponent } from '../fame-hall/fame-hall.component';
import { GalleryComponent } from '../gallery/gallery.component';
import { RecordComponent } from "../record/record.component";
import { MemberUnitComponent } from "../member-unit/member-unit.component";
import { RTIComponent } from "../rti/rti.component";
import { GovermentSectionComponent } from "../goverment-section/goverment-section.component";
import { MiscellaneousSanctionalOrdersComponent } from "../miscellaneous-sanctional-orders/miscellaneous-sanctional-orders.component";
import { KheloIndiaSanctionalOrdersComponent } from "../khelo-indian-sanctional-orders/khelo-indian-sanctional-orders.component";
import { CoachingCampSanctionalOrdersComponent } from "../coaching-camp-sanctional-orders/coaching-camp-sanctional-orders.component";
import { NationalSanctionalOrdersComponent } from "../national-sanctional-orders/national-sanctional-orders.component";
import { InternationalSanctionalOrdersComponent } from "../international-sanctional-orders/international-sanctional-orders.component";
import { HarassmentComponent } from "../sexual-harassment/harassment.component";
  

const routes: Routes = [
  {
    path: "",
    component: NavbarComponent,
    children: [
      { path: "", component: HomepageComponent },
  { path: 'member-unit', component: MemberUnitComponent },

      { path: "about", component: AboutComponent },
      { path: "history", component: HistoryComponent },
      { path: "rules", component: RulesComponent },
      { path: "award/:id", component: AwardsComponent },
      { path: "archers", component: ArchersComponent },
      { path: "achievements", component: AchievementsComponent },
      { path: "calendar", component: CalanderComponent },
      { path: "news", component: NewsComponent },
      { path: "compliance", component: ComplianceComponent },
      { path: "judges", component: JudgesComponent },
      { path: 'news-detail/:id', component: NewsDetailComponent },

      { path: "executive", component: ExecutiveCommiteeComponent },

      { path: "commities", component: CommittesComponent },

      { path: "gcArchers", component: GcComponent },
      { path: "rti", component: RTIComponent },
      { path: "sexual-harassment", component: HarassmentComponent },
      { path: "compliance-committee-women", component: HarassmentComponent },
      
      { path: "goverment-section", component: GovermentSectionComponent },
      { path: "goverment-section-international", component: InternationalSanctionalOrdersComponent },
      { path: "goverment-section-national", component: NationalSanctionalOrdersComponent },
      { path: "goverment-section-coaching-camp", component: CoachingCampSanctionalOrdersComponent },
      { path: "goverment-section-khelo-india", component: KheloIndiaSanctionalOrdersComponent },
      { path: "goverment-section-miscellaneous", component: MiscellaneousSanctionalOrdersComponent },
      
      { path: "annualAccounts", component: AnnualAccountsComponent },

      { path: "results", component: ResultsComponent },
      { path: "records", component: RecordComponent },


      { path: "events", component: EventsComponent },
      { path: 'event-detail/:id', component: EventDetailsComponent },
      { path: "fame-hall", component: FameHallComponent },
      { path: "gallery", component: GalleryComponent },


    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NavbarRoutingModule {}
